export default __webpack_public_path__ + "static/media/backer-redhat-capital.31715372.png";